<template>
    <div class="main">
        <p class="summary">
            PhenoBank houses high-content screening data from three C. elegans screens characterizing essential genes. It retrieves phenotypic annotations and identifies genes with matched phenotypes across different biological contexts.
            <a href="#" @click="showImageModal=true">Project Summary</a>
        </p>

        <div v-if="showImageModal">
            <transition name="modal">
                <div class="modal-mask">
                    <div class="modal-wrapper">
                        <div class="modal-dialog modal-viewer">
                            <div class="modal-content modal-viewer">
                                <div class="modal-header">
                                    <button type="button" class="close" @click="showImageModal=false">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                    <h4 class="modal-title">Overall Project Summary</h4>
                                </div>
                                <div class="modal-body" style="font-size: 16px;">
                                    Phenobank is a repository of functional genomic phenotypic data from three C. elegans screens characterizing the set of genes essential for embryo production, division, and development (~3000 genes). <br/><br/>

                                    Each gene in the set was knocked down using RNAi, and the phenotypic consequences were assessed by imaging either germline morphology (<router-link to="/embdProjectDescription">Green et al., 2011</router-link>), early embryonic divisions (<router-link to="/eecdProjectDescription">Sonnichsen et al., 2005</router-link>) and/or embryonic development (<router-link to="/embdProjectDescription">Green, Khaliullin et al., 2024</router-link>). <br/><br/>

                                    Each movie was described and scored for a variety of defects, either manually (Sonnichsen et al., 2005, Green et al., 2011) or through automated means (Green, Khaliullin et al., 2024), and conditions with matched phenotypic profiles were identified and ranked according to similarity metrics.<br/><br/>

                                    Top phenotypic matches for each biological context are displayed and links to the primary data for each hit are provided. This set of ~3000 genes represents the majority of non-redundant genes essential for embryogenesis in a model metazoan.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>

        <h3>Search</h3>
        <form class="form-horizontal" onSubmit="return false;">
            <div class="form-group">
                <label class="control-label col-sm-3" for="keyword">Gene name or keyword: </label>
                <div class="col-sm-4">
                    <input class="form-control input-sm" id="keyword" v-model="keyword" type="text" placeholder="Enter search term. (e.g. unc-52, GO:0009887)"/>
                </div>
            </div>
            <div class="form-group">
                <div class="col-sm-offset-3 col-sm-10">
                    <button class="button btn-default btn-sm" type="submit" @click="searchWithKeyword">Search</button>
                </div>
            </div>
        </form>


        <fetch-search ref="search" :keyword="keyword">
            <template slot-scope="{response, loading}">
                <div v-if="loading">Loading...</div>
                <div v-else>
                    <data-table id='dataTable' :data='response' :keyword='keyword'/>
                </div>
            </template>
        </fetch-search>
    </div>
</template>

<script>
  import DataTable from '@/components/DataTable.vue'
  import FetchSearch from "./FetchSearch";

  export default {
    name: 'SearchPage',
    components: {
      FetchSearch, DataTable
    },
    data() {
      return {
        keyword: this.$route.params.keyword,
        showImageModal: false,
      }
    },
    methods: {
      searchWithKeyword() {
        const vm = this
        vm.searchKeyword = vm.keyword
        const url = `/search/${vm.keyword}`
        // // eslint-disable-next-line
        // console.log(url)
        // window.open(url)
        this.$router.push({ path: url })
        vm.$refs.search.fetch(vm.keyword)
        /* eslint-disable no-console */
        // console.log(this.searchKeyword)
      }
    },
    mounted() {
      // console.log(this.keyword)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    @import url('~@/assets/bootstrap.css');
    @import url('~@/assets/datatable.css');
    @import url('~@/assets/tooltip.css');

    .main {
        margin: 1.5rem;
    }

    h3 {
        margin: 40px 0 0;
    }

    a {
        color: #0066ff;
    }

    p.summary {
        color: #114188;
        line-height: 1.2;
        font-weight: normal;
        font-style: oblique;
        font-size: 15px;
    }
</style>
